import { RequestResponse } from '@/common/types_and_interfaces.ts'
import { parseRequestError } from '@/common/utilities.ts'
import axiosInstance from '@/libs/axios_config.ts'
import { z } from 'zod'

export const GetProgramSettingsEndpoint = '/program/settings/:program_id'

const IntegrationSettingSchema = z.object({
  id: z.number(),
  code: z.enum(['CLEAR_ME']),
  status: z.number(),
})

const ProgramSettingsSchema = z.object({
  id: z.number(),
  status: z.number(),
  name: z.string().nullable(),
  global_state_id: z.number(),
  enrollment_start_date: z.string(),
  enrollment_end_date: z.string(),
  program_start_date: z.string(),
  program_end_date: z.string(),
  application_documents_deadline: z.string().nullable(),
  new_application_end_date: z.string(),
  new_application_start_date: z.string(),
  require_renewal_income: z.boolean(),
  class_wallet: z.boolean(),
  isApplicationOpen: z.boolean(),
  global_timezone_code: z.string(),
  acceptable_income_year: z.string(),
  integrations: z.array(IntegrationSettingSchema).min(0),
  marketplace_module: z.number(),
  send_bill_module: z.number(),
  reimbursement_module: z.number(),
  pay_provider_module: z.number(),
  require_family_bank_info_for_reimbursement: z.number(),
})

export type ProgramSettingsResp = z.infer<typeof ProgramSettingsSchema>

export const GETProgramSettings = async (
  programId: number
): Promise<RequestResponse<ProgramSettingsResp>> => {
  try {
    const response = await axiosInstance.get(
      GetProgramSettingsEndpoint.replace(':program_id', programId.toString())
    )

    return {
      data: ProgramSettingsSchema.parse({
        ...response.data,
      }),
      error: null,
    }
  } catch (e) {
    return { data: null, error: parseRequestError(e) }
  }
}
